module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Prompts","button":"Add a prompt"}}')
  delete Component.options._Ctor
}
